module.exports = __webpack_public_path__ + "img/p1.f61b78c8.png";